import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "./registerServiceWorker";
// import VueAuth from '@d0whc3r/vue-auth-plugin';
// import axios from 'axios'
// import VueAxios from 'vue-axios';
import "@websanova/vue-auth";
// import VueI18n from 'vue-i18n'

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// import VueAuthenticate from 'vue-authenticate'

import CardLoading from "./components/shared/cardLoading";
import SnackComp from "./components/shared/snackComp";
import i18n from "./i18n";

import VueAnalytics from "vue-analytics";
// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: "UA-163513977-1",
  router
});

// let messages = require('../locales/pt_BR.js')
// Vue.use(VueI18n)
// const i18n = new VueI18n({
//   locale: 'pt_BR', // set locale
//   messages
// })

// Vue.use(VueAxios, axios)
// Vue.axios.defaults.baseURL = 'http://192.168.0.155:3000';

Vue.component("card-loading", CardLoading);
Vue.component("snack-comp", SnackComp);

Vue.use(VueSweetalert2);

Vue.use(require("@websanova/vue-auth"), {
  auth: require("@websanova/vue-auth/drivers/auth/devise.js"),
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  tokenStore: ["localStorage", "cookie"],
  rolesVar: "role",
  loginData: {
    url: "/auth/sign_in",
    method: "POST",
    redirect: "/",
    fetchUser: true
  },
  logoutData: {
    url: "/auth/sign_out",
    method: "POST",
    redirect: "/",
    fetchUser: false,
    makeRequest: true
  },
  fetchData: { url: "/user", method: "GET", atInit: true },
  refreshData: {
    url: "auth/refresh",
    enabled: false,
    method: "GET",
    atInit: false
  },
  authRedirect: { path: "/login" },
  parseUserData: function(data) {
    // console.log(data);
    return data;
  }
});

Vue.use(Vuetify, {
  theme: {
    primary: "#003a3e"
  }
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
